import React, { useEffect } from "react";

export default function PlaylistPushAlternative() {
  useEffect(() => {
    const title =
      "Playlist Push Alternative 2025: Soundope Costs 90% Less & Delivers Real Plays";
    document.title = title;

    const description =
      "Soundope is the real Playlist Push alternative in 2025: $1 submissions with simple $1–$4 tiers instead of $250–$1,000 campaigns, 100% verified human curators, and real Spotify & Apple Music placements.";

    const metaTags = [
      { type: "name", key: "description", content: description },
      {
        type: "name",
        key: "keywords",
        content:
          "playlist push alternative, cheaper than playlist push, playlist promotion, spotify playlist promotion, real streams, no bots",
      },
      { type: "name", key: "robots", content: "index, follow" },

      // Open Graph
      { type: "property", key: "og:title", content: title },
      { type: "property", key: "og:description", content: description },
      { type: "property", key: "og:type", content: "website" },
      { type: "property", key: "og:url", content: window.location.href },

      // Twitter
      { type: "name", key: "twitter:card", content: "summary_large_image" },
      { type: "name", key: "twitter:title", content: title },
      { type: "name", key: "twitter:description", content: description },

      // Canonical
      {
        type: "link",
        key: "canonical",
        content: window.location.origin + "/playlist-push-alternative",
      },
    ];

    metaTags.forEach(({ type, key, content }) => {
      if (type === "link") {
        let tag = document.querySelector(`link[rel="${key}"]`);
        if (tag) {
          tag.setAttribute("href", content);
        } else {
          tag = document.createElement("link");
          tag.setAttribute("rel", key);
          tag.setAttribute("href", content);
          document.head.appendChild(tag);
        }
      } else {
        const selector =
          type === "property"
            ? `meta[property="${key}"]`
            : `meta[name="${key}"]`;
        let tag = document.querySelector(selector);

        if (tag) {
          tag.setAttribute("content", content);
        } else {
          tag = document.createElement("meta");
          tag.setAttribute(type, key);
          tag.setAttribute("content", content);
          document.head.appendChild(tag);
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen px-4 py-16 pb-32 bg-[#050505]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-light mb-6 text-[#f5f5f5]">
          Soundope: The Only Real Playlist Push Alternative That Actually Works
        </h1>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Playlist Push wants $250–$1,000+ per campaign for botted playlists and
          fake streams.
        </p>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Soundope does the same job (often better) with $1–$4 submissions instead of $250–$1,000 campaigns:
        </p>

        <ul className="list-disc list-inside space-y-2 text-[#d0d0d0] mb-6">
          <li>$1 per submission — no $450 "campaign" nonsense</li>
          <li>100% verified human curators — no botted garbage lists</li>
          <li>Real Spotify &amp; Apple Music adds — no stream fraud</li>
          <li>Feedback on every track — Playlist Push never gives</li>
          <li>Free submissions available</li>
        </ul>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Stop burning thousands on Playlist Push’s payola machine. Get real
          curator placements for pocket change.
        </p>

        <a
          href="/signup"
          className="inline-block px-6 py-3 rounded-full bg-[#b61f3d] text-white text-sm md:text-base font-semibold tracking-wide hover:bg-[#e0254c] transition-colors"
        >
          Switch from Playlist Push — Start Free
        </a>

        <div className="mt-4">
          <a
            href="/Upload"
            className="inline-block px-6 py-3 rounded-full bg-transparent border border-[#b61f3d] text-[#f5f5f5] text-sm md:text-base font-semibold tracking-wide hover:bg-[#b61f3d] hover:text-white transition-colors"
          >
            Upload a track now
          </a>
        </div>
      </div>
    </div>
  );
}


